import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Optional_Subject_ListAPI, Week_Category_ListAPI } from "../../../helper/Redux/Slices/DDLSlice/DDLSlice";
import { RegExEmail, RegExMobile, RegExNumbersOnly, RegExOnlyText } from "../../../helper/Regx";
import { convertBase64 } from "../../../helper/Base64Converter/Base64ConverterFile";
import { ExamFormDetailsPostAPI } from "../../../helper/Redux/Slices/ExamFormDetailsSlice/ExamFormDetailsSlice";
import { NEFTRTGSDetailsPopUp } from "./NEFTRTGSDetailsPopUp";
import { GPAYUPIQRDetailsPopUp } from "./GPAYUPIQRDetailsPopUp";
import { TermsAndConditionPopUp } from "./TermsAndConditionPopUp";

export const OpenPopUp = (props) => {
    const { LicentiateCertificateID, LicentiateCertificateSubMenuID, SelectedSubID, setSelectedSubID, SelectedSubName } = props
    const dispatch = useDispatch();
    const [IsPost, setIsPost] = useState(false)
    const [loader, setloader] = useState(false)
    const [formData, setFormData] = useState({
        fullName: '',
        age: '',
        contactNumber: '',
        organizationName: '',
        examReason: '',
        examFees: '',
        email: ''
    });

    const [Reciept, setReciept] = useState("");
    const [FileTypeExtension, setFileTypeExtension] = useState("");
    const [selectedIndicatorID, setSelectedIndicatorID] = useState('');
    const [selectedWeekIndicatorID, setselectedWeekIndicatorID] = useState('');
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [IsDisable, setIsDisable] = useState(false)
    const [IsValidText, setIsValidText] = useState(false)
    const [IsValidMobile, setIsValidMobile] = useState(false)
    const [IsValidEmail, setIsValidEmail] = useState(false)
    const [isFormSubmitted, setIsFormSubmitted] = useState(false)

    const handleInputChange = (e) => {
        const { name, value, } = e.target;

        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    const [TermsandConditionModal, setTermsandConditionModal] = useState(false);

    // terms and conditions modal
    const handleTermsConditionModalOpen = (e) => {
        if (termsAccepted) {
            setTermsAccepted(false);
        } else {
            setTermsAccepted(e.target.checked);
            setTermsandConditionModal(true)
        }
        // handleTermsConditionModalOpen();
    }
    const handleTermsConditionModalClose = () => {
        setTermsandConditionModal(false)
        // handleTermsConditionModalOpen();
    }

    console.log(termsAccepted)

    // const handleTermsChange = (e) => {
    //     setTermsAccepted(e.target.checked);
    // };

    const handleRadioChange = (value) => {
        setSelectedIndicatorID(value);
    };
    const handleWeekRadioChange = (value) => {
        setselectedWeekIndicatorID(value);
    };

    const handleCheckText = (e) => {
        handleInputChange(e)
        const IsValid = RegExOnlyText(e.target.value)
        setIsValidText(IsValid)
        return IsValid
    }
    const handleCheckMobile = (e) => {
        handleInputChange(e)
        const IsValid = RegExMobile(e.target.value)
        setIsValidMobile(IsValid)
        return IsValid
    }

    const handleCheckNumber = (e) => {
        const IsValid = RegExNumbersOnly(e.target.value)
        if (!IsValid) {
            handleInputChange(e)
        }
        return IsValid
    }

    const handleCheckEmail = (e) => {
        handleInputChange(e)
        const IsValid = RegExEmail(e.target.value)
        setIsValidEmail(IsValid)
        return IsValid
    }

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        try {
            const base64 = await convertBase64(file);
            setReciept(base64.split(",")[1]);
            setFileTypeExtension(`.${file.name.split(".").pop()}`);
        } catch (error) {
            console.error("Error converting file to Base64", error);
        }
    };


    useEffect(() => {
        if (formData.fullName == '' || formData.age == '' || formData.contactNumber == '' || formData.examReason == '' ||
            formData.examFees == '' || selectedIndicatorID == "" || selectedWeekIndicatorID == "" || Reciept == "" || FileTypeExtension == "" || formData.email == '' ||
            IsValidText || IsValidMobile || !termsAccepted) {
            setIsDisable(true)
        } else {
            setIsDisable(false)
        }
    }, [formData, selectedIndicatorID, termsAccepted, selectedWeekIndicatorID])


    const handleSubmit = () => {
        setloader(true)
        const data = {
            M_MainSubjectID: LicentiateCertificateID,
            M_SubSubjectID: LicentiateCertificateSubMenuID,
            OptionalSub_M_IndicatorID: SelectedSubID ? SelectedSubID : 0,
            FullName: formData.fullName,
            Age: formData.age,
            ContactNumber: formData.contactNumber,
            Email: formData?.email,
            Category_M_IndicatorID: selectedIndicatorID,
            Week_Category_M_IndicatorID: selectedWeekIndicatorID,
            Name_Of_Organization: formData.organizationName,
            ExaminationPurpose: formData.examReason,
            PaidExamFee: formData.examFees,
            UploadReceipt: Reciept,
            UploadReceiptExtension: FileTypeExtension,
            handleIsPost: handleIsPost
        }
        dispatch(ExamFormDetailsPostAPI({ data }))
    }

    const handleIsPost = () => {
        handleClearForm()

        setloader(false)
        setIsPost(!IsPost)
        setIsFormSubmitted(true)
    }

    const handleClearForm = () => {
        setFormData({
            fullName: '',
            age: '',
            contactNumber: '',
            organizationName: '',
            examReason: '',
            examFees: '',
        });
        setTermsAccepted(false)
        setSelectedIndicatorID('')
        setselectedWeekIndicatorID('')
        setFileTypeExtension('')
        setReciept('')
        setIsValidMobile(false)
        setIsValidText(false)
    }

    useEffect(() => {
        getListData()
        getWeekListData()
    }, [IsPost])

    const getListData = () => {
        const data = {
            M_UserID: 0,
            Flag: "Master"
        }
        dispatch(Optional_Subject_ListAPI({ data }))
    }

    const { DDLData, isLoading } = useSelector(state => state.Optional_Subject_ListData)


    const getWeekListData = () => {
        const data = {
            M_UserID: 0,
            Flag: "Week_Category"
        }
        dispatch(Week_Category_ListAPI({ data }))
    }

    const { WeekData, isWeekLoading } = useSelector(state => state.Week_Category_ListData)


    const cancelbtn = () => {
        if (SelectedSubID != 0) {
            setSelectedSubID && setSelectedSubID(0)
        }
    }
    const [neft, setNeft] = useState(false)
    const handleNEFTModalOpen = () => {
        setNeft(!neft);
    }
    const [UPIQR, setUPIQR] = useState(false)
    const handleUPIQRModalOpen = () => {
        setUPIQR(!UPIQR);
    }

    const [selectedOption, setSelectedOption] = useState(null);

    const handleNEFT = () => {
        setSelectedOption(1);
        handleNEFTModalOpen();
    };

    const handleUPI = () => {
        setSelectedOption(2);
        handleUPIQRModalOpen();
    };

    return (
        <>

            <div className="row p-2 m-0 bg-white col-lg-12 mt-3 mx-auto p-4 rounded shadow" >

                {SelectedSubName &&
                    <>
                        <h5 className="text-center pb-2 text-dark">{SelectedSubName}</h5>
                        <hr />
                    </>
                }

                <div className="my-2 col-12 pb-3 col-lg-6 ">
                    <label htmlFor="fullName" className="form-label ">Full Name:</label>
                    <input type="text" className="form-control" id="fullName"
                        name="fullName"
                        value={formData.fullName}
                        onChange={e => handleCheckText(e)} />
                    {
                        IsValidText && <text className="RegxValidation">Please enter Alphabet characters only</text>
                    }
                </div>

                <div className="my-2 col-12 pb-3 col-lg-6 ">
                    <label htmlFor="age" className="form-label ">Age (in years):</label>
                    <input type="text" className="form-control" id="age"
                        name="age"
                        value={formData.age}
                        onChange={e => handleCheckNumber(e)}
                        maxLength={2} />
                </div>
                <div className="my-2 col-12 pb-3 col-lg-6 ">
                    <label htmlFor="contactNumber" className="form-label ">Contact Number:</label>
                    <input type="text" className="form-control" id="contactNumber"
                        name="contactNumber"
                        value={formData.contactNumber}
                        onChange={e => handleCheckMobile(e)}
                        maxLength={10}
                    />
                    {
                        IsValidMobile && <text className="RegxValidation">Please enter atleast minimum 10 digit Valid Number</text>
                    }
                </div>

                <div className="my-2 col-12 pb-3 col-lg-6 ">
                    <label htmlFor="contactNumber" className="form-label ">Email ID:</label>
                    <input type="text" className="form-control" id="email"
                        name="email"
                        value={formData.email}
                        onChange={e => handleCheckEmail(e)}
                    />
                    {
                        IsValidEmail && <text className="RegxValidation">Please enter Valid Email ID</text>
                    }
                </div>

                <div className="col-lg-6 pt-5">
                    <div className="row">
                        {DDLData && DDLData?.table && DDLData.table.length > 0 && DDLData.table.map((i, j) => (
                            <div key={j} className="my-2 col-12 col-lg-4 px-md-0 px-xl-4">
                                <input
                                    type="radio"
                                    id={`indicator-${j}`}
                                    name="indicator"
                                    value={i?.indicator_Name}
                                    checked={selectedIndicatorID === i?.m_IndicatorID}
                                    onChange={() => handleRadioChange(i?.m_IndicatorID)}
                                />
                                <label htmlFor={`indicator-${j}`} className="form-label ps-2 text-nowrap">
                                    {i?.indicator_Name}
                                </label>
                            </div>
                        ))}

                    </div>
                </div>

                <div className="my-2 col-12 col-lg-6 ">
                    <label htmlFor="organizationName" className="form-label ">If Employed, Name of the Organization:</label>
                    <input type="text" className="form-control" id="organizationName"
                        name="organizationName"
                        value={formData.organizationName}
                        onChange={handleInputChange} />
                </div>
                <div className="my-2 col-12 col-lg-6 ">
                    <label htmlFor="examReason" className="form-label ">Why do you want to take this examination?</label>
                    <textarea type="text" className="form-control" id="examReason"
                        name="examReason"
                        value={formData.examReason}
                        onChange={handleInputChange} />
                </div>
                <div className="my-2 col-12 col-lg-6 ">
                    <label htmlFor="examFees" className="form-label ">Paid Exam Fees</label>
                    <input type="text" className="form-control" id="examFees"
                        name="examFees"
                        value={formData.examFees}
                        onChange={e => handleCheckNumber(e)} />
                </div>
                <div className="my-2 col-12 col-lg-6 ">
                    <label htmlFor="exampleFormControlInput1" className="form-label ">Upload Receipt</label>
                    <input type="file" className="form-control"
                        id="document"
                        name="document"
                        // accept="application/pdf"
                        placeholder=""
                        onChange={handleFileChange}
                    // required
                    />
                    {/* {
                        IsValidFile && <text className="RegxValidation">Please upload less than 3 MB file</text>
                    } */}
                </div>

                <div className="col-lg-6">
                    <div className="row mt-2">
                        <label htmlFor="exampleFormControlInput1" className="form-label ">Choose Batch :</label>
                        {WeekData && WeekData?.table && WeekData.table.length > 0 && WeekData.table.map((i, j) => (
                            <div key={j} className="col-12 col-lg-12 px-md-0 px-xl-4 ">
                                <input
                                    type="radio"
                                    id={`Weekindicator-${j}`}
                                    name="Weekindicator"
                                    value={i?.indicator_Name}
                                    checked={selectedWeekIndicatorID == i?.m_IndicatorID}
                                    onChange={() => handleWeekRadioChange(i?.m_IndicatorID)}
                                />
                                <label htmlFor={`Weekindicator-${j}`} className="form-label text-nowrap ps-2">
                                    {i?.indicator_Name}

                                    {
                                        i?.m_IndicatorID == 22 ?
                                            <label className="ps-2">-&nbsp;&nbsp;(Monday/Wednesday/Friday)</label>
                                            :
                                            i?.m_IndicatorID == 23 ?

                                                <label className="ps-2">-&nbsp;&nbsp;(Friday/Saturday)</label>
                                                :
                                                <label className="ps-2">-&nbsp;&nbsp;(Tuesday/Thursday/Friday)</label>
                                    }

                                </label>
                            </div>
                        ))}

                    </div>
                </div>

                <div className="my-1 col-12 col-lg-6">
                    <input type="checkbox" id="termsAccepted"
                        name="termsAccepted"
                        className="cursor-pointer "
                        title="Please check this box to Accept Terms and Condition"
                        // onChange={handleTermsConditionModalOpen}
                        checked={termsAccepted}
                        onChange={(e) => {
                            e.preventDefault();
                            setTermsandConditionModal(true);
                        }}
                        onClick={(e) => {
                            e.preventDefault();
                            setTermsandConditionModal(true);
                        }}
                        required
                    />
                    <label htmlFor="termsAccepted" className="form-label ps-2 pt-2 text-primary">Terms and Condition</label>
                </div>


                <div className="row text-center border-top pt-4">
                    <div className="col-12 text-start">
                        <div className="row ">
                            <h5> Payment Details</h5>
                            <div className="col-12 py-2">
                                <span className="cursor-pointer" title="Please check this box to open NEFT/RTGS Details">
                                    <input
                                        type="checkbox"
                                        className="me-2 cursor-pointer"
                                        checked={selectedOption === 1}
                                        onChange={handleNEFT}
                                        disabled={IsDisable}
                                    />
                                    NEFT/RTGS Details
                                </span>

                                <br />

                                <span className="cursor-pointer mt-2" title="Please check this box to open G-Pay UPI QR Details">
                                    <input
                                        type="checkbox"
                                        className="me-2 cursor-pointer"
                                        checked={selectedOption === 2}
                                        onChange={handleUPI}
                                        disabled={IsDisable}
                                    />
                                    G-Pay UPI QR Details
                                </span>
                            </div>
                        </div>
                        <hr />
                    </div>
                    <div className="col-12">
                        <button
                            type='button'
                            disabled={IsDisable}
                            onClick={handleSubmit}
                            className="w-80 btn addbtn btn-success  m-2 px-4" data-ktwizard-type="action-next">
                            {loader ?
                                <><i className="fa fa-refresh fa-spin" style={{ fontSize: "15px", marginRight: "5px" }}></i>
                                    Loading..</> :
                                <> <i className="fa-solid fa-floppy-disk pe-1"></i> Submit</>}
                        </button>
                        <button
                            type="button"
                            onClick={() => cancelbtn()}
                            className="w-80  btn addbtn btn-danger  m-2 px-4" data-ktwizard-type="action-next">
                            <i className="fa-solid fa-xmark pe-1"></i> Cancel

                        </button>
                    </div>
                </div>
                {isFormSubmitted && <p className="text-success text-center">Form Submitted Successfully</p>}
            </div>


            {
                neft ?
                    <NEFTRTGSDetailsPopUp
                        cancelbtn={handleNEFTModalOpen}
                        heading="NEFT/RTGS Details"
                    /> :
                    <></>

            }
            {
                UPIQR ?
                    <GPAYUPIQRDetailsPopUp
                        cancelbtn={handleUPIQRModalOpen}
                        heading="G-Pay UPI QR Details"
                    /> :
                    <></>

            }
            {
                TermsandConditionModal ?
                    <TermsAndConditionPopUp
                        cancelbtn={handleTermsConditionModalClose}
                        heading="Terms and Condition"
                        isAccepted={termsAccepted}
                        setIsAccepted={setTermsAccepted}
                    /> :
                    <></>

            }
        </>
    )
}


